import { render, staticRenderFns } from "./omt-b.vue?vue&type=template&id=337cb801&scoped=true&"
import script from "./omt-b.vue?vue&type=script&lang=js&"
export * from "./omt-b.vue?vue&type=script&lang=js&"
import style0 from "./omt-b.vue?vue&type=style&index=0&id=337cb801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337cb801",
  null
  
)

export default component.exports